@if (shouldRender) {
  @if (componentData$ | async; as data) {
    <a  [href]="data.urlLink"
      [target]="data.external == 'true' ? '_blank' : '_self'"
      (click)="onLinkClick($event, data.urlLink)">
      @if (data.headline) {
        <p [innerHTML]="data.headline"></p>
      }
      <cx-media [container]="data.media"></cx-media>
      @if (data.content) {
        <p [innerHTML]="data.content"></p>
      }
    </a>
  }
}
